  // Function to process input text (convert to lowercase and remove spaces)
  export const processInput = (text) => {
    return text.toLowerCase().replace(/\s+/g, '');
  };